import { constants } from '@pukka/common';
import { Text } from '@pukka/ui-components';
import { useFlagWithFallback } from '@pukka/unleash';
import { FaPhoneAlt, FaInfoCircle } from 'react-icons/fa';

import { LanguagePicker } from '../LanguagePicker';

const { TAG_VERSION } = constants;

function SidebarFooter() {
  const [enableMultiLanguage] = useFlagWithFallback('backoffice-multi-language');

  return (
    <div className="flex flex-col items-center bg-legacy-500 pb-5 pt-3">
      {enableMultiLanguage && (
        <div className="mb-3">
          <LanguagePicker />
        </div>
      )}

      <Text as="span" variant="caption-1" className="mb-3 flex items-center justify-center text-light-blue-300">
        <FaPhoneAlt className="mr-2" />
        1500970
      </Text>
      <Text
        as="a"
        target="__blank"
        href="https://help.mokapos.com/s/topic/0TO5h000000dV10GAE/moka-pos?language=in&tabset-38dc2=2"
        variant="body-1"
        color="white"
        className="flex h-8 items-center rounded bg-light-blue-500"
      >
        <span className="mr-1 flex h-full items-center pl-4">
          <FaInfoCircle />
        </span>
        <span className="flex h-full items-center pr-4">Tutorials & Help</span>
      </Text>
      <div className="absolute bottom-0 right-0 h-4 w-20 text-xs text-neutral-300">{TAG_VERSION}</div>
    </div>
  );
}

export { SidebarFooter };
